module.exports = {"en":{"feedback":"Feedback","bugreport":"Report a bug"},"de":{"feedback":"Rückmeldungen","bugreport":"Fehler melden"},"fr":{"feedback":"Retours","bugreport":"Signaler un bug"},"ru":{"feedback":"Обратная связь","bugreport":"Сообщить о проблемах"},"ja":{"feedback":"Feedback","bugreport":"Report a bug"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/SideContainer/side-container.json
// module id = 925
// module chunks = 0